import React from 'react';
import { useApp } from '../../context/AppContext';
import { COLLS } from '../../constants';

export default function DealRoomScreen() {
  const { playbooks, go, setActivePbIdx, toast } = useApp();
  const sentPlaybooks = playbooks.filter(pb => pb.status === 'sent');

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '14px', padding: '18px 24px 14px', borderBottom: '1px solid var(--border)', flexShrink: 0, background: 'white' }}>
        <div style={{ width: '38px', height: '38px', borderRadius: '11px', background: '#EDE9FE', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <i className="ti ti-building" style={{ fontSize: '20px', color: '#7C3AED' }} />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: '20px', fontWeight: '800', color: 'var(--navy)' }}>Deal Rooms</div>
          <div style={{ fontSize: '12px', color: 'var(--text3)' }}>All active deal workspaces — click to open</div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          {[{ label: 'Active', value: sentPlaybooks.length, color: '#22C55E' }, { label: 'Views today', value: 12, color: 'var(--navy)' }, { label: 'Hot', value: 2, color: '#EF4444' }].map(s => (
            <div key={s.label} style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '20px', fontWeight: '800', color: s.color }}>{s.value}</div>
              <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{s.label}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Alert banner */}
      <div style={{ padding: '10px 24px', background: '#FFFBEB', borderBottom: '1px solid #FDE68A', flexShrink: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', maxWidth: '900px' }}>
          <i className="ti ti-bell-ringing" style={{ fontSize: '15px', color: '#B45309', flexShrink: 0 }} />
          <span style={{ fontSize: '12px', color: '#92400E', fontWeight: '600' }}>Priya Sharma is viewing Q2 Product Pitch right now — 8 min on pricing page 🔥</span>
        </div>
      </div>

      {/* Deal room cards */}
      <div style={{ flex: 1, overflowY: 'auto', padding: '20px 24px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(320px,1fr))', gap: '16px', maxWidth: '1200px', alignContent: 'start' }}>
          {sentPlaybooks.map((pb, idx) => {
            const colls = (pb.colls || []).map(i => COLLS[i]).filter(Boolean);
            const globalIdx = playbooks.indexOf(pb);
            return (
              <div key={idx} style={{ background: 'white', border: '1.5px solid var(--border)', borderRadius: '14px', overflow: 'hidden', cursor: 'pointer', transition: 'all .18s' }}
                onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 8px 24px rgba(0,0,0,.1)'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                onMouseLeave={e => { e.currentTarget.style.boxShadow = ''; e.currentTarget.style.transform = ''; }}
                onClick={() => { setActivePbIdx(globalIdx); go('client'); }}>

                {/* Color header */}
                <div style={{ padding: '16px 18px', background: pb.dealRoom.color, position: 'relative', minHeight: '80px' }}>
                  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '8px' }}>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: 'white', flex: 1, marginRight: '10px' }}>{pb.dealRoom.label}</div>
                    <span style={{ fontSize: '9px', fontWeight: '700', padding: '3px 10px', borderRadius: '20px', background: pb.dealRoom.accent + '30', color: pb.dealRoom.accent, border: `1px solid ${pb.dealRoom.accent}60`, flexShrink: 0 }}>{pb.dealRoom.stage}</span>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                    <i className={`ti ${pb.dealRoom.stageIco}`} style={{ color: pb.dealRoom.accent, fontSize: '13px' }} />
                    <span style={{ fontSize: '11px', color: 'rgba(255,255,255,.7)' }}>{pb.name}</span>
                  </div>
                </div>

                <div style={{ padding: '14px 18px' }}>
                  {/* Recipients */}
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px' }}>
                    {pb.recipients.map((r, i) => (
                      <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                        <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: 'var(--navy)', color: 'var(--gold)', fontSize: '9px', fontWeight: '700', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{r.ini}</div>
                        <div>
                          <div style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy)' }}>{r.name}</div>
                          <div style={{ fontSize: '10px', color: 'var(--text3)' }}>{r.org}</div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Stats */}
                  <div style={{ display: 'flex', gap: '14px', marginBottom: '12px' }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--navy)' }}>{pb.views}</div>
                      <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>Views</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--navy)' }}>{pb.opens}</div>
                      <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>Opens</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{ fontSize: '18px', fontWeight: '800', color: 'var(--navy)' }}>{colls.length}</div>
                      <div style={{ fontSize: '9px', color: 'var(--text3)', fontWeight: '600', textTransform: 'uppercase' }}>Files</div>
                    </div>
                  </div>

                  {/* Security badges */}
                  <div style={{ display: 'flex', gap: '5px', marginBottom: '12px' }}>
                    {pb.security.otp && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#EBF8FF', color: '#1E4E8C' }}>🔐 OTP</span>}
                    {pb.security.expiry && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#FDF4E7', color: '#7A5A1A' }}>⏱ Expires {pb.security.expiry}</span>}
                    {pb.security.blockFwd && <span style={{ fontSize: '9px', fontWeight: '700', padding: '2px 8px', borderRadius: '20px', background: '#FFF5F5', color: '#C53030' }}>🚫 No forward</span>}
                  </div>

                  {/* Action buttons */}
                  <div style={{ display: 'flex', gap: '7px' }} onClick={e => e.stopPropagation()}>
                    <button onClick={() => { setActivePbIdx(globalIdx); go('client'); }} style={{ flex: 1, padding: '8px', borderRadius: '8px', background: 'var(--navy)', border: 'none', color: 'white', fontFamily: 'inherit', fontSize: '11px', fontWeight: '600', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                      <i className="ti ti-eye" /> Open
                    </button>
                    <button onClick={() => toast('Analytics opened')} style={{ flex: 1, padding: '8px', borderRadius: '8px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
                      <i className="ti ti-chart-bar" /> Stats
                    </button>
                    <button onClick={() => toast('Share link copied!')} style={{ padding: '8px 10px', borderRadius: '8px', border: '1.5px solid var(--border2)', background: 'white', fontFamily: 'inherit', fontSize: '11px', color: 'var(--text2)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}>
                      <i className="ti ti-share" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
